import { gql, useQuery } from "@apollo/client";
import { Card, EmptyState, Heading, Layout, Page, ResourceItem, ResourceList, TextStyle, Thumbnail } from "@shopify/polaris";
import { Helmet } from "react-helmet";
import {ENUM_LABEL_VALUE} from "../utils/ENUM_LABEL_VALUE.query";

export default function Channels() {
    const title = 'Channels'
    const { data: { __type: { enumValues: channelGroups } } = { __type: { enumValues: [] } } } = useQuery(ENUM_LABEL_VALUE, { variables: { type: 'ChannelGroup' } })
    const { data: { channels: { nodes: channels } } = { channels: { nodes: [] } }, loading } = useQuery(gql`{channels{nodes{id name group}}}`)
    return (
        <Page title={title} primaryAction={{ content: 'Add', url: '/settings/channels/new' }} breadcrumbs={[{ content: 'Settings', url: '/settings' }]}>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <Layout>
                <Layout.AnnotatedSection
                    title={title}
                    // description="Accept channels on your store using providers like CMI, Cash on Delivery, PayPal, or other payment methods."
                >
                    <Card>
                        <ResourceList
                            items={channels}
                            loading={loading}
                            renderItem={
                                channel => (<ResourceItem url={`/settings/channels/${channel.id}`} key={channel.id} >
                                    <Heading><TextStyle keyvariation="strong">{channel.name}</TextStyle></Heading>
                                    <p>{channelGroups.find(channelGroup => channel.group == channelGroup.value).label}</p>
                                </ResourceItem>)
                            }
                            emptyState={
                                <EmptyState
                                    heading="Add your Channel"
                                    action={{ content: 'Add', url: '/settings/channels/new' }}
                                    fullWidth
                                />
                            }
                        />
                    </Card>
                </Layout.AnnotatedSection>
            </Layout>
        </Page>
    )
}